The `PositionProfile` that was updated.

This may return null if the `PositionProfile` has been closed for an extended period of time.

This field is only accessible while you have an active `ApplicationExport` or `JobPosting` relationship with the hirer.
If these relationships have been removed, it will return null along with a `FORBIDDEN` error.
